"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApMonthPickerGrid = void 0;
/* tslint:disable */
var React = require("react");
var react_1 = require("react");
/* tslint:enable */
var ApButtons_1 = require("../ApButtons");
var styles_1 = require("./styles");
exports.ApMonthPickerGrid = function (_a) {
    var selectDirection = _a.selectDirection, handleSelect = _a.handleSelect, handleDeIncYear = _a.handleDeIncYear, handleIncYear = _a.handleIncYear, currentYear = _a.currentYear, completedSrcRange = _a.completedSrcRange;
    var _b = __read(react_1.useState(Object.keys(completedSrcRange).length - 1), 1), totalYears = _b[0];
    var createYearTable = function (year) {
        return year
            .reduce(function (allYears, oneYear, i) {
            var chunkSize = Math.floor(i / 4);
            allYears[chunkSize] = [].concat(allYears[chunkSize] || [], oneYear);
            return allYears;
        }, [])
            .map(function (yearChunk, y) {
            return (React.createElement("tr", { key: "tr-" + y }, yearChunk.map(function (obj, i) {
                return (React.createElement("td", { key: "td-" + i },
                    React.createElement(styles_1.StyledPickerButton, { key: "button-" + i, disabled: obj.isDisabled, onClick: function () {
                            return handleSelect({
                                month: obj.month,
                                monthNumber: obj.monthNumber,
                                year: obj.year,
                            });
                        }, isDisabled: obj.isDisabled, isSelectable: obj.isSelectable, isSelected: obj.isSelected }, obj.month)));
            })));
        });
    };
    return (React.createElement(styles_1.StyledPickerContainer, null,
        React.createElement(styles_1.StyledPickerTableHeader, null,
            React.createElement(styles_1.StyledContolsTitle, null,
                selectDirection,
                ":"),
            React.createElement(styles_1.StyledContols, null,
                React.createElement(ApButtons_1.ApButtonIcon, { disabled: currentYear === 0 ? true : false, iconName: "baseline_arrow_back", onClick: handleDeIncYear }),
                React.createElement("span", { style: { margin: '0px 8px' } }, Object.keys(completedSrcRange)[currentYear]),
                React.createElement(ApButtons_1.ApButtonIcon, { disabled: currentYear === totalYears ? true : false, iconName: "baseline_arrow_forward", onClick: handleIncYear }))),
        Object.keys(completedSrcRange).map(function (year, i) {
            return (React.createElement(styles_1.StyledPickerTableContainer, { key: "table-container-" + i, id: year, style: {
                    display: year === Object.keys(completedSrcRange)[currentYear]
                        ? 'block'
                        : 'none',
                } },
                React.createElement(styles_1.StyledPickerTable, { key: "table-" + i },
                    React.createElement(styles_1.StyledPickerTBody, null, createYearTable(completedSrcRange[year])))));
        })));
};
//# sourceMappingURL=ApMonthPickerGrid.js.map